<template>
	<div class="currency-flag">
		<img
			class="currency-flag__img"
			src="@/assets/img/flags/nigerian-flag.svg"
			v-if="currency === 'NGN'"
			:alt="currency"
		/>
		<img
			class="currency-flag__img"
			src="@/assets/img/flags/kenyan-flag.svg"
			v-if="currency === 'KES'"
			:alt="currency"
		/>
		<img
			class="currency-flag__img"
			src="@/assets/img/flags/usa-flag.svg"
			v-if="currency === 'USD'"
			:alt="currency"
		/>
		<!-- Fallback for GBP, EUR, and unknown currencies -->
		<div 
			v-if="!['NGN', 'KES', 'USD'].includes(currency)"
			class="currency-flag__fallback"
			:class="{
				'currency-flag__fallback--gbp': currency === 'GBP',
				'currency-flag__fallback--eur': currency === 'EUR'
			}"
		>
			{{ getCurrencyIcon(currency) }}
		</div>
	</div>
</template>

<script setup>
defineProps({
	currency: {
		type: String,
		required: true,
	},
});

const getCurrencyIcon = (currency) => {
	switch (currency) {
		case 'GBP': return '£';
		case 'EUR': return '€';
		default: return currency?.charAt(0) || '?';
	}
};
</script>

<style lang="scss" scoped>
.currency-flag {
	width: 24px;
	height: 24px;
	flex-shrink: 0;

	&__img {
		width: 24px;
		height: 24px;
		border-radius: 50%;
		object-fit: cover;
	}

	&__fallback {
		width: 24px;
		height: 24px;
		border-radius: 50%;
		background: #E2E8F0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 12px;
		font-weight: 600;
		color: #475569;

		&--gbp {
			background: #1E3A8A;
			color: white;
		}

		&--eur {
			background: #1D4ED8;
			color: #FCD34D;
		}
	}
}
</style>
